import { Activity, FC } from 'react';

import MwdTooltip from '@/apps/mwd-v2/components/MwdTooltip/MwdTooltip';
import AdvancedSearchDialog from '@/components/dialogs/advancedSearch/AdvancedSearchDialog';
import { SearchParams } from '@/components/search/types';
import SidebarWithMainContentPanels from '@/views/mwdView/SidebarWithMainContentPanels';
import useSearchAndSidebarWerklijnen from '@/views/mwdView/useSearchAndSidebarWerklijnen';
import useSidebar from '@/views/mwdView/useSidebar';

import SearchStatus from '../../components/search/components/SearchStatus/SearchStatus';

import Controls from './components/Controlbar/Controlbar';
import Werklijnen from './components/Domain/Werklijnen';
import MwdActions from './components/MwdActions/MwdActions';
import MwdChart from './components/MwdChart/MwdChart';
import MwdPlankDropOverlay from './components/MwdPlankDropOverlay/MwdPlankDropOverlay';
import useGeneralShortkeys from './hooks/useGeneralShortkeys';
import useSearchStatusStore from './state/selectors/useSearchStatusStore';

const MwdView: FC = () => {
  const {
    handleSelectieUitPanel,
    showAdvancedSearchDialog,
    setShowAdvancedSearchDialog,
    handleAdvancedSearchData,
    setAdvancedSearchParams,
    clearAdvancedSearchData,
    searchParams,
  } = useSearchAndSidebarWerklijnen();

  const { activePanel, setActivePanel } = useSidebar();

  useGeneralShortkeys({
    handleSelectieUitPanel,
  });

  const { isSearching, showNoSearchResults, showNothingToShow } = useSearchStatusStore();
  return (
    <>
      <SidebarWithMainContentPanels
        handleSelectieUitPanel={handleSelectieUitPanel}
        activePanel={activePanel}
        setActivePanel={setActivePanel}
      >
        <SearchStatus
          isFetching={isSearching}
          searchParams={searchParams}
          noSearchResultFound={showNoSearchResults}
          nothingToShow={showNothingToShow}
        />
        <Activity mode={!showNoSearchResults && !showNothingToShow && !isSearching ? 'visible' : 'hidden'}>
          <Controls />
          <MwdChart>
            <Werklijnen />
          </MwdChart>
        </Activity>
      </SidebarWithMainContentPanels>
      <MwdPlankDropOverlay />
      <MwdTooltip />
      <AdvancedSearchDialog
        showDialog={showAdvancedSearchDialog}
        handleOpenChange={setShowAdvancedSearchDialog}
        handleAdvancedSearchData={handleAdvancedSearchData}
        handleAdvancedSearchParams={setAdvancedSearchParams as (searchParams: SearchParams) => void}
        clearAdvancedSearchData={clearAdvancedSearchData}
        title='Geavanceerd zoeken'
      />
      <MwdActions />
    </>
  );
};
export default MwdView;
